import { btcAssetId, fromAssetId, isAssetReference, solAssetId } from '@shapeshiftoss/caip';
import { isNativeEvmAsset } from '../../utils/helpers/helpers';
import { DEFAULT_RELAY_EVM_TOKEN_ADDRESS, RELAY_BTC_TOKEN_ADDRESS, RELAY_SOLANA_TOKEN_ADDRESS, } from '../constant';
export const getRelayAssetAddress = (asset) => {
    if (asset.assetId === btcAssetId)
        return RELAY_BTC_TOKEN_ADDRESS;
    if (asset.assetId === solAssetId)
        return RELAY_SOLANA_TOKEN_ADDRESS;
    if (isNativeEvmAsset(asset.assetId))
        return DEFAULT_RELAY_EVM_TOKEN_ADDRESS;
    const { assetReference } = fromAssetId(asset.assetId);
    return isAssetReference(assetReference)
        ? DEFAULT_RELAY_EVM_TOKEN_ADDRESS
        : assetReference;
};
